var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Prohibited",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <g id="svg-fg">
    <path d="M41.28,22.72a13.12,13.12,0,1,0,0,18.55A13,13,0,0,0,41.28,22.72ZM25.2,25.2a9.61,9.61,0,0,1,12.25-1.12L24.08,37.45A9.63,9.63,0,0,1,25.2,25.2ZM38.8,38.8a9.61,9.61,0,0,1-12.25,1.12L39.92,26.55A9.63,9.63,0,0,1,38.8,38.8Z"/>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/assets/icons/prohibited.svg